import Dexie from "dexie";

export const db = new Dexie("curengoDatabase");
db.version(1).stores({
  chats: "sessionId",
});
